import { render, staticRenderFns } from "./paymentCodePage.vue?vue&type=template&id=45ce568b&scoped=true&"
import script from "./paymentCodePage.vue?vue&type=script&lang=js&"
export * from "./paymentCodePage.vue?vue&type=script&lang=js&"
import style0 from "./paymentCodePage.vue?vue&type=style&index=0&id=45ce568b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce568b",
  null
  
)

export default component.exports